// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Aml9","info":"PatientInfo_info__MGJ7X"};